import React, { Component } from 'react';
import '../css/style.css';
import '../components/Home.css';
import Booked from '../components/pubevent/Booked';
import SimpleLayout from './SimpleLayout';
import { translate } from "react-i18next";



class BookedLayout extends Component {


   render(){
      const { t } = this.props;
    const { params } = this.props.match
     return (<SimpleLayout title= {t("bookings")} eventKey="2">
     <Booked eventId={params.id} title={params.title}  />
 </SimpleLayout>)
   }

}

export default translate("translations")(BookedLayout);